import { useEffect, useState } from "react";
import type { Match } from "@/types/match";
import { api } from "@/services/api";

export function useSearch(query: string, debounceMs = 250) {
  const [results, setResults] = useState<Match[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    const trimmed = query.trim();
    if (!trimmed) {
      setResults([]);
      setIsSearching(false);
      return;
    }
    setIsSearching(true);
    const handle = setTimeout(async () => {
      try {
        const data = await api.search(trimmed);
        setResults(data);
      } finally {
        setIsSearching(false);
      }
    }, debounceMs);

    return () => clearTimeout(handle);
  }, [query, debounceMs]);

  return { results, isSearching };
}
